import BaseModule from "./base-module";

class Address extends BaseModule {
  // 添加
  createAddress(payload) {
    return this.postt("/v1/customeraddress", payload);
  }

  // 获取当前登录用户所有的地址
  loadAddress(params) {
    return this.get("/v1/customeraddress/all", { params });
  }

  // 根据Guid,获取一条
  loadAddressDetail(params) {
    return this.get("/v1/customeraddress", { params });
  }

  // 修改
  updateAddress(payload) {
    return this.post("/v1/customeraddress/update", payload);
  }

  // 删除
  deleteAddress(payload) {
    return this.post("/v1/customeraddress/delete", payload);
  }
}

export default new Address();
